module.exports = __webpack_public_path__ + "static/img/gaozhongzhengzhi3.3b0b0118.jpg";